import React from 'react';
import { Link } from 'react-router-dom';
import './CreditsDisplay.css';

const CreditsDisplay = ({ credits, loading }) => {
  if (loading || !credits) return null;

  const { balance } = credits;
  const isLow = balance > 0 && balance < 2;
  const isZero = balance === 0;

  return (
    <Link to="/credits" className={`credits-display ${isLow ? 'credits-low' : ''} ${isZero ? 'credits-zero' : ''}`}>
      {isZero ? (
        <span className="credits-cta">0 credits — Buy Credits</span>
      ) : (
        <>
          <span className="credits-icon">●</span>
          <span className="credits-balance">{balance}</span>
          <span className="credits-label">credit{balance !== 1 ? 's' : ''}</span>
          {isLow && <span className="credits-warning">Low balance</span>}
        </>
      )}
    </Link>
  );
};

export default CreditsDisplay;
